export type HistoryResponseGuardOptions = {
  sessionId: string;
  currentSessionId: string | null | undefined;
  loadedHistorySessionId: string | null | undefined;
  activeLoadSessionId: string | null | undefined;
  expectedRequestSeq?: number;
  responseRequestSeq?: number | null;
};

// 历史响应必须同时属于当前会话、当前加载窗口和最新请求。
export function getHistoryResponseIgnoreReason(options: HistoryResponseGuardOptions): string | null {
  if (options.sessionId !== options.currentSessionId) return 'stale_current_session';
  if (options.loadedHistorySessionId !== options.sessionId) return 'history_session_not_loaded';
  if (options.activeLoadSessionId && options.activeLoadSessionId !== options.sessionId) return 'stale_active_load';
  if (
    Number.isFinite(options.expectedRequestSeq)
    && Number.isFinite(options.responseRequestSeq)
    && options.expectedRequestSeq !== options.responseRequestSeq
  ) return 'stale_request_sequence';
  return null;
}
